<div class="profile-edit-phone">

    @for (phoneControl of phoneControls; track $index) {
    <div class="profile-edit-phone-item">

        <div class="profile-edit-phone-item-header">

            <div class="profile-edit-phone-item-header-title">
                {{ 'PHONES_EDIT_FORM.TITLES.PHONE' | translate }} {{ $index + 1 }}
            </div>

            <rpc-button class="profile-edit-phone-item-header-btn" [color]="'warn'"
                [text]="'PHONES_EDIT_FORM.TITLES.DELETE'" [iconName]="'delete-bin'" (clicked)="onRemovePhone($index)">
            </rpc-button>

        </div>

        <div class="profile-edit-phone-item-body">

            <rpc-select class="profile-edit-phone-item-body-select" [color]="'accent'"
                [label]="'PHONES_EDIT_FORM.TITLES.TYPE'" [controlOptions]="phoneControl.selectOptions"
                [appearance]="'fill'">
            </rpc-select>

            <phone-form-input class="profile-edit-phone-item-body-input" [appearance]="'fill'"
                [parentForm]="phoneControl.form" [controlName]="'number'" [phoneNumberInfo]="phoneControl.phoneInfo"
                [isPhoneRequired]="true" [isFormatValidationRequired]="true"
                [countriesPhoneInfo]="countriesPhoneInfo()">
            </phone-form-input>

        </div>

        <div class="profile-edit-phone-item-toggle-wrap">

            <rpc-slide-toggle class="profile-edit-phone-item-toggle" [controlName]="'isAlertReceiver'"
                [checked]="phoneControl.phoneInfo.isAlertReceiver"
                [firstText]="'PHONES_EDIT_FORM.TITLES.USE_FOR_ALERTS'"
                [hint]="'PHONES_EDIT_FORM.TITLES.USE_FOR_ALERTS_INFO'" (changed)="onAlertReceiverChanged(phoneControl)">
            </rpc-slide-toggle>

        </div>

    </div>
    }

    <div class="profile-edit-phone-add-wrap">

        <rpc-button [color]="'accent'" [iconName]="'add-new'" [text]="'PHONES_EDIT_FORM.TITLES.ADD_NEW'"
            (clicked)="onAddPhone()">
        </rpc-button>

    </div>

</div>